<template>
	<v-card elevation="0" class="top-divider py-2">
		<v-row no-gutters>
			<v-select
				v-if="valueOptions.length"
				v-model="ledgerSearchOption.name"
				label="表示名(必須)"
				ref="input"
				:items="valueOptions"
				item-value="name"
				item-text="name"
				:rules="[rules.required]"
				required
				dense
				outlined
				@change="changeLedgerSearchOption"
			/>
			<template v-else-if="columnType == 'date' || columnType == 'datetime'">
				<v-menu
					ref="menu"
					v-model="menu"
					:close-on-content-click="false"
					:return-value.sync="ledgerSearchOption.name"
					transition="scale-transition"
					offset-y
					min-width="auto"
				>
					<template v-slot:activator="{ on, attrs }">
						<v-text-field
							v-model="ledgerSearchOption.name"
							label="表示名(必須)"
							:rules="[rules.required]"
							ref="input"
							outlined
							dense
							readonly
							v-bind="attrs"
							v-on="on"
						></v-text-field>
					</template>
					<v-date-picker
						v-model="ledgerSearchOption.name"
						no-title
						scrollable
						@change="changeLedgerSearchOption"
					>
						<v-spacer></v-spacer>
						<v-btn text color="primary" @click="menu = false"> キャンセル </v-btn>
						<v-btn text color="primary" @click="$refs.menu.save(ledgerSearchOption.name)">
							決定
						</v-btn>
					</v-date-picker>
				</v-menu>
			</template>
			<v-select
				v-else-if="columnType == 'boolean'"
				v-model="ledgerSearchOption.name"
				label="表示名(必須)"
				ref="input"
				:items="booleanOptions"
				item-value="id"
				item-text="name"
				:rules="[rules.required]"
				required
				dense
				outlined
				@change="changeLedgerSearchOption"
			/>
			<v-text-field
				v-else
				v-model="ledgerSearchOption.name"
				label="表示名(必須)"
				ref="input"
				:rules="[rules.required]"
				required
				dense
				outlined
				@blur="changeLedgerSearchOption"
			/>
			<v-menu offset-y close-on-click>
				<template v-slot:activator="{ on, attrs }">
					<v-btn text color="red" v-bind="attrs" v-on="on"> 削除 </v-btn>
				</template>
				<v-list>
					<v-list-item @click="$emit('delete-ledger-search-option')">
						<v-list-item-title color="red" class="text-body-2">本当に削除する</v-list-item-title>
					</v-list-item>
				</v-list>
			</v-menu>
		</v-row>
	</v-card>
</template>
<script>
import rules from "../../../helper/rules"
import moment from "moment/min/moment.min.js"

export default {
	props: {
		ledgerSearchOptionData: Object,
		valueOptions: Array,
		columnType: String,
	},
	filters: {
		dateFormatter: function (date) {
			if (!date) return ""
			return moment(date).format("YYYY/MM/DD")
		},
		timeFormatter: function (time) {
			if (!time) return ""
			return moment(time).format("HH:mm")
		},
	},
	data() {
		return {
			ledgerSearchOption: {
				uuid: null,
				name: null,
				value_string: null,
				value_boolean: null,
				value_integer: null,
				value_float: null,
			},
			rules: rules,
			showForm: true,
			showOptionBtn: false,
			booleanOptions: [
				{ id: "1", name: "真である" },
				{ id: "0", name: "偽である" },
			],
			menu: false,
		}
	},
	mounted() {
		this.ledgerSearchOption = this.ledgerSearchOptionData
		this.$refs.input.resetValidation()
	},
	methods: {
		changeLedgerSearchOption() {
			const selectedValue = this.valueOptions.length
				? this.valueOptions.find((v) => v.name == this.ledgerSearchOption.name)
				: null
			const value = selectedValue != null ? selectedValue.id : this.ledgerSearchOption.name
			switch (this.columnType) {
				case "string":
				case "text":
				case "date":
				case "datetime":
					this.ledgerSearchOption.value_string = value
				case "integer":
					this.ledgerSearchOption.value_integer = value
				case "float":
					this.ledgerSearchOption.value_float = value
				case "boolean":
					this.ledgerSearchOption.value_boolean = value == "1" ? true : false
			}
			this.$emit("change-ledger-search-option", this.ledgerSearchOption)
		},
	},
	computed: {
		value() {
			switch (this.columnType) {
				case "string":
				case "text":
				case "date":
				case "datetime":
					return this.ledgerSearchOption.value_string
				case "integer":
					return this.ledgerSearchOption.value_integer
				case "float":
					return this.ledgerSearchOption.value_float
				case "boolean":
					return this.ledgerSearchOption.value_boolean
			}
		},
		valueDate() {
			if (!this.ledgerSearchOption.name)
				return moment(this.ledgerSearchOption.name).format("YYYY年MM月DD日")
		},
	},
	watch: {
		ledgerSearchOptionData(newValue, _) {
			this.ledgerSearchOption = newValue
		},
		valueOptions(newValue, _) {
			this.valueOptions = newValue
		},
		columnType(newValue, _) {
			this.columnType = newValue
		},
		deep: true,
	},
}
</script>

<style scoped lang="scss">
@import "../../../stylesheet/shared/color.scss";
.ledger-search-form {
	padding: 8px;
	&:not(:first-child) {
		border-top: 1px solid whitesmoke;
	}
}
.v-toolbar__content {
	padding: 0;
}
</style>